export const REASONS_OPTIONS = [
  { value: "1", label: "Камера перекрыта" },
  { value: "2", label: "Камера повреждена" },
  { value: "3", label: "Камера выключена" },
  { value: "4", label: "Ракурс не соответствует требованиям" },
  {
    value: "5",
    label: "Изображение низкого качества / некорректное изображение",
  },
  { value: "6", label: "Некорректная зона" },
  { value: "7", label: "Проблема с сетью/питанием" },
  { value: "8", label: "Проблема с интернетом" },
  { value: "9", label: "Неверное наименование камеры/отсутствует тариф" },
  { value: "other", label: "Другое" },
];

export const defaultValue = {
  reason: "",
  reasonList: { label: "", value: "" },
};
